import { useEffect, useState } from "react";
import { FirestoreService } from "../../../../../api/firebase/firestoreService";
import { FirestoreDocumentReference } from "../../../../../api/firebase/references";
import { capitalizeWordsSeperatedByUnderScore } from "../../../../../utils/stringModifications";

export interface NarAgentGridInsuranceOption {
  value: string;
  label: string;
}

/**
 * Loads payer/insurance dropdown options from Firestore on mount.
 */
export const useNarAgentGridInsuranceOptions = () => {
  const [insuranceOptions, setInsuranceOptions] = useState<
    NarAgentGridInsuranceOption[]
  >([]);

  useEffect(() => {
    const fetchInsuranceOptions = async () => {
      try {
        const options = await FirestoreService.getDocument(
          FirestoreDocumentReference.insuranceOptions("payer_mapping"),
        );

        const payerKeys = Object.keys(options as string)
          .filter((key) => key !== "id")
          .sort();

        const formattedOptions = payerKeys.map((key: string) => ({
          value: key,
          label: capitalizeWordsSeperatedByUnderScore(key),
        }));

        setInsuranceOptions(formattedOptions);
      } catch (error) {
        console.error("Error fetching insurance options:", error);
      }
    };

    void fetchInsuranceOptions();
  }, []);

  return { insuranceOptions };
};

export default useNarAgentGridInsuranceOptions;
